import React from 'react';
import p80 from '../resorcesfiles/ideak/p80.jpg'; // Replace with the appropriate image path
import Mainmastet from '../masterpage/Mainmastet';
import U300 from '../resorcesfiles/ideak/u300.jpg'


const AboutUs = () => {
  return (
    <Mainmastet content={<>
    
    <div style={styles.container}>
    <div style={{height:'20px'}}></div>

      <header style={styles.header}>
        <h1 style={styles.title}>About Us</h1>
      </header>
      <section style={styles.section}>
        <h2 style={styles.subTitle}>Who We Are</h2>
        <p style={styles.text}>
          We are a leading company specializing in RFID tags, barcode tags, and printers. Our expertise extends to barcode scanners and software development for scanning and asset management.
        </p>
        <p style={styles.text}>
          Our mission is to advance your business to new levels by providing cutting-edge solutions for tracking and managing assets with unparalleled accuracy and efficiency.
        </p>
      </section>
      <section style={styles.section}>
        <h2 style={styles.subTitle}>Our Services</h2>
        <ul style={styles.list}>
        <li style={styles.listItem}>RFID Readers</li>
        <li style={styles.listItem}>Barcode Reader</li>
        <li style={styles.listItem}>RFID Tags</li>
        <li style={styles.listItem}>Barcode Tags</li>
        <li style={styles.listItem}>Printers</li>
        <li style={styles.listItem}>Asset Tagging</li>
        <li style={styles.listItem}>Software Development for Scanning and Asset Management</li>
        </ul>
      </section>
      <section style={styles.section}>
        <h2 style={styles.subTitle}>RFID in Warehouse Management</h2>
        <p style={styles.text}>
          Our RFID warehouse management system processes RFID tag data from readers and links them to the warehouse management system, improving efficiency and accuracy.
        </p>
        <p style={styles.text}>
          RFID tags are attached to pallets, shelves, and locations, and RFID readers are mounted on forklifts to read the tags. This system automates tracking and provides real-time management capabilities.
        </p>
        <img src={U300} alt="RFID Warehouse Management" style={styles.image} />
      </section>
      <section style={styles.section}>
        <h2 style={styles.subTitle}>RFID Asset Tracking Management</h2>
        <p style={styles.text}>
          Our RFID asset tracking system automates asset tracking, improving data accuracy and security. It allows staff to easily locate and identify assets and track their movement for maintenance or disposal.
        </p>
        <p style={styles.text}>
          Typical applications include IT asset tracking, office equipment tracking, hospital asset tracking, and more.
        </p>
      </section>
      <div style={{height:'50px'}}></div>
    </div>

    
    </>} />
  );
};

const styles = {
  container: {
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f8f9fa',
    color: '#343a40',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  header: {
    backgroundColor: '#007bff',
    color: 'white',
    padding: '10px 0',
    textAlign: 'center',
    borderRadius: '5px'
  },
  title: {
    margin: 0,
    fontSize: '2.5em'
  },
  section: {
    margin: '20px 0'
  },
  subTitle: {
    fontSize: '1.8em',
    borderBottom: '2px solid #007bff',
    paddingBottom: '10px'
  },
  text: {
    fontSize: '1.2em',
    lineHeight: '1.6em',
    margin: '10px 0'
  },
  list: {
    listStyleType: 'none',
    paddingLeft: 0
  },
  listItem: {
    fontSize: '1.2em',
    margin: '5px 0',
    padding: '5px 0',
    borderBottom: '1px solid #ddd'
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: '5px',
    margin: '20px 0'
  }
};

export default AboutUs;
